<template>
    <DefaultBackground>
        <header class="bg-white border-b border-light-gray text-center fixed w-full z-10">
            <vue-custom-scrollbar>
                <nav v-if="currentStep.route !== 'orders.edit.success'" class="inline-block whitespace-no-wrap select-none mx-0 md:mx-10 lg:mx-16">
                    <a v-for="(step, index) in steps" :key="step.step" class="inline-block py-4 mx-6 border-primary step-nav-item cursor-pointer" :class="[step.active ? 'active' : '', step.passed ? 'passed' : '', step.route === 'orders.edit.success' ? 'pointer-events-none' : '']" @click="navigateTo(step)">
                        <div class="font-medium flex items-center">
                            <div class="inline-block w-5 h-5 rounded-full border-2 flex items-center justify-center step--icon">
                                <span class="text-sm font-semibold">
                                    {{ index + 1 }}
                                </span>
                            </div>
                            <div class="ml-2 step--title">
                                {{ step.title }}
                            </div>
                        </div>
                    </a>
                </nav>
            </vue-custom-scrollbar>
        </header>

        <div class="pt-20">
            <section class="block sm:hidden">
                <div class="flex flex-row flex-wrap">
                    <button class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 flex-1 m-2" @click="$router.push('/')" :disabled="progressSaving">
                        <span>Cancel</span>
                    </button>
                    <button class="btn btn-primary font-semibold rounded-lg px-10 min-w-10 flex-1 m-2" @click="onSaveAndExit">
                        <span v-if="!progressSaving">Save & Exit</span>
                        <Spinner class="mx-auto" v-if="progressSaving" />
                    </button>
                </div>
            </section>
            <div class="lg:mt-2">
                <transition :name="transition" mode="out-in">
                    <router-view @back="onBackButtonPressed" @nextButtonPressed="onSubmit"></router-view>
                </transition>
            </div>
        </div>
        <transition name="fade">
            <LoadingOverlay v-if="progressLoading"></LoadingOverlay>
        </transition>

        <SigninSignupModal
            v-if="showAuthModal"
            @onLoginSuccess="onLoginSuccess"
            @onLoginCancel="showAuthModal = false"
        />

    </DefaultBackground>
</template>

<script>
import DefaultBackground from "@/components/common/layout/DefaultBackground"
import Spinner from "@/components/common/Spinner"
import LoadingOverlay from "@/components/common/LoadingOverlay"
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { mapGetters } from 'vuex'
import SigninSignupModal from '../../components/common/auth/SigninSignupModal.vue'

export default {
    name: "ViewsCatererSignup",
    components: {
        LoadingOverlay,
        Spinner,
        DefaultBackground,
        vueCustomScrollbar,
        SigninSignupModal
    },
    data() {
        return {
            steps: [{
                step: 1,
                title: 'Business Details',
                route: 'caterer.signup.details',
                active: true,
                passed: false
            }, {
                step: 2,
                title: 'Categories',
                route: 'caterer.signup.categories',
                active: false,
                passed: false
            }, {
                step: 3,
                title: 'Line Items',
                route: 'caterer.signup.items',
                active: false,
                passed: false
            }, {
                step: 4,
                title: 'Review Menu',
                route: 'caterer.signup.review',
                active: false,
                passed: false
            }, {
                step: 5,
                title: 'Success',
                route: 'caterer.signup.success',
                active: false,
                passed: false
            }],
            transition: 'slide-right-fade',
            progressLoading: false,
            showAuthModal: false,
            shouldExit: false,
        }
    },
    beforeCreate(){
        this.$root.$on('catererProcessSaveExit', () => this.onSaveAndExit())
    },
    beforeDestroy() {
        this.$root.$off('catererProcessSaveExit', () => this.onSaveAndExit())
        this.$root.$off('catererLoaded', data => this.setAvailableSteps(data))
    },
    computed: {
      ...mapGetters(['isAuthenticated', 'getCatererDetails', 'personalDetails']),

        currentStep() {
            return this.steps.find(step => step.route === this.$route.name)
        },
        progressSaving: {
            get() {
                return this.$store.state.isSavingCurrentOrder
            },
            set(value) {
                this.$store.commit('setIsSavingCurrentOrder', value)
            }
        }
    },
    watch: {
        $route(to, from) {
            // Customize slide transition based on the step navigation.
            const stepTo = this.steps.find(step => step.route === to.name)?.step ?? 0
            const stepFrom = this.steps.find(step => step.route === from.name)?.step ?? 0
            if (stepTo <= stepFrom) {
                this.transition = 'slide-right-fade'
            } else {
                this.transition = 'slide-left-fade'
            }
        }
    },
    
    async mounted() {
        if (this.getCatererDetails == null) {
            this.navigateTo(this.steps[0]);
        } else {
            this.highlightActiveStep();
        }

        this.$root.$on('catererLoaded', data => this.setAvailableSteps(data))
    },
    
    methods: {

        setAvailableSteps(caterer) {

            this.setActiveStep(1);

            if(caterer.categories_count > 0) {
                this.setActiveStep(2);
            }

            if(caterer.items_count > 0) {
                this.setActiveStep(3);
            }

            if(caterer.categories_count > 0 && caterer.items_count > 0) {
                this.setActiveStep(4);
                this.setActiveStep(5);
            }
        },

        setActiveStep(index) {
            this.steps.map( step => {
                if(step.step == index) {
                    step.passed = true;
                    return step;
                }
            })
        },
        
        highlightActiveStep() {
            this.currentStep.active = true;
            const index = this.steps.indexOf(this.currentStep);
            
            for(let a = 0; a < index; a++) {
                this.steps[a].passed = true;
                this.steps[a].active = false;
            }
        },
        canEditItems() {
            return true;
        },

        canNavigateTo(stepToNavigate) {
     
            return this.steps.every(step => {
                if (step.step < stepToNavigate.step) {
                    if (!step.passed) {
                        return false
                    }
                }
                return true
            })
        },
        async navigateTo(stepToNavigate) {
            if (this.canNavigateTo(stepToNavigate) && this.currentStep.route !== stepToNavigate.route) {
                
                await this.$router.replace({
                    name: stepToNavigate.route
                })
                this.steps.every(step => {
                    step.active = step.step === stepToNavigate.step
                    return true
                })
            }
        },
        onBackButtonPressed() {
            const prevSteps = this.steps.filter(step => step.step < this.currentStep.step);
            const prevStep = prevSteps[prevSteps.length - 1];
            if (prevStep) {
                this.navigateTo(prevStep)
            } else {
                this.$router.back()
            }
        },
        onSubmit() {
            if (this.shouldExit) {
                this.progressSaving = false
                this.$router.push('/caterer/dashboard')
            } else {
                // Update step passed status, and navigate to the next step.
                this.steps.every(step => {
                    if (step.step === this.currentStep.step) {
                        step.passed = true
                        return false
                    }
                    return true
                })
                const nextStep = this.steps.find(step => step.step > this.currentStep.step)
                this.navigateTo(nextStep)
            }
        },

        
        onSaveAndExit() {
            // if authenticated  - try save current step data
            // if not authenticated - first login / signup - then try save current step data
            this.shouldExit = true
            if (!this.$store.getters.isAuthenticated) {
                this.showAuthModal = true
            } else {
                this.onLoginSuccess()
            }
        },
        async onLoginSuccess() {
            this.showAuthModal = false;
            this.$root.$emit('catererTrySubmitStep')
        }
    }
}
</script>

<style lang="scss" scoped>
.step-nav-item {
    .step--icon {
        @apply bg-white border-gray-600 text-gray-600 transition duration-200;
    }

    .step--title {
        @apply text-gray-600 transition duration-200;
    }

    &.active {
        @apply border-b-2 border-primary;
    }

    &.passed {
        .step--icon {
            @apply bg-primary border-primary text-white;
        }

        .step--title {
            @apply text-primary;
        }
    }

    &:hover {
        .step--icon {
            @apply bg-primary border-primary text-white;
        }

        .step--title {
            @apply text-primary;
        }
    }
}
</style>
